var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social-media-container"},_vm._l((_vm.mediaContacts),function(media){return _c('div',{key:media.name,staticClass:"icon-container"},[_c('a',{attrs:{"href":media.url,"target":"blank"}},[_c('MartzIcon',{staticClass:"icon",attrs:{"icon":media.icon,"size":25}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }